import { defineComponent as _defineComponent } from 'vue'
import VsHeading from '@/components/vision/VsHeading.vue'
import VsText from '@/components/vision/VsText.vue'
import RemoveSignatureConfirmationDialog from '@/components/jobs/sections/RemoveSignatureConfirmationDialog.vue'
import JobSignature from '@/models/job-signature'
import {
  useJobSignatureQuery,
  useDeleteSignatureMutation,
} from '@/api/signature'
import { computed, ref } from 'vue'
import { formatDateTimeWithYear } from '@/utils/date-formatting'
import { ApprovalStatus, JobStatus } from '@/models/job'
import { useJobBottomSheetStatesStore } from '@/components/jobs/jobBottomSheetStatesStore'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsButton from '@/components/vision/VsButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'JobSignature',
  props: {
    jobId: null,
    jobStatus: null,
    jobApprovalStatus: null,
    signature: null
  },
  emits: ["clear-signature"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'clear-signature')
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  jobId: string
  jobStatus: string
  jobApprovalStatus: string
  signature: JobSignature | null
}



const signatureIdRef = computed(() => props.signature?.id)

const {
  data: signatureBlob,
  isInitialLoading,
  isLoading,
  isError,
  error: signatureError,
} = useJobSignatureQuery(props.jobId, signatureIdRef)

const { mutateAsync: deleteSignature } = useDeleteSignatureMutation()
const jobBottomSheetStatesStore = useJobBottomSheetStatesStore()



const showConfirmationDialog = ref<boolean>()

const canEditSignature = computed(() => {
  return (
    signatureError.value?.status !== 403 &&
    (props.jobStatus === JobStatus.PAUSED ||
      props.jobStatus === JobStatus.ACTIVE ||
      (props.jobStatus === JobStatus.COMPLETED &&
        props.jobApprovalStatus !== ApprovalStatus.APPROVED))
  )
})

const signatureURL = computed(() => {
  if (!signatureBlob.value) return null
  return URL.createObjectURL(signatureBlob.value)
})

const buttonLabel = computed(() => {
  if (props.signature == null) {
    return 'Add signature'
  } else {
    return 'Re-sign'
  }
})

const clearSignature = async () => {
  if (!props.signature) return

  await deleteSignature({
    signatureId: props.signature.id,
    jobId: props.jobId,
  })

  showConfirmationDialog.value = false
  emit('clear-signature')
}

const openSignatureBottomSheet = () => {
  jobBottomSheetStatesStore.setJobBottomSheetStates({
    isSignatureBottomSheetVisible: true,
  })
}

return { __sfc: true,props, signatureIdRef, signatureBlob, isInitialLoading, isLoading, isError, signatureError, deleteSignature, jobBottomSheetStatesStore, emit, showConfirmationDialog, canEditSignature, signatureURL, buttonLabel, clearSignature, openSignatureBottomSheet, VsHeading, VsText, RemoveSignatureConfirmationDialog, formatDateTimeWithYear, VsWrapper, VsButton }
}

})